import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Link from 'react-router-dom/Link'

import { TextBox } from 'srcReact/components/common2/TextBox'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'

import { settingsActions } from '../../action'
import styles from './styles.module.scss'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import { getFlagEmoji, setCookie, urlSearchParams } from 'srcReact/helpers/utils'
import { appConstantSettings } from '../../../appConstantSettings'
import { getCurrentLanguageFromCookie } from '../../../helpers/utils'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { commonActions } from 'srcReact/components/actions'
import { redirectToPage } from 'srcReact/helpers/history'
import CloseAccountModal from '../CloseAccountModal'
import TransferRoleModal from '../TransferRoleModal'
import { checkNested } from 'srcReact/helpers/validator'
import { loginActions } from 'srcReact/LoginPage'
import { formatDate, getDateFormat2 } from 'srcReact/helpers/datetimeHelper'

export default function MainForm({ openCloseAccountModal }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    organization,
    settings: { userDetails, firstNameObj, lastNameObj, language: languageFromReducer, nameUpdated },
    common: { isNative, isMobile, languages },
    organization: {
      header: { user_properties }
    }
  } = useSelector((state) => state)
  const {
    firstname,
    lastname,
    email,
    phone_number,
    birthday,
    gender,
    country_code,
    language,
    success,
    loading: userDetailLoading
  } = userDetails

  const [firstNameIp, setFirstNameIp] = useState('')
  const [lastNameIp, setLastNameIp] = useState('')
  const [phoneNumber, setPhoneNumber] = useState(phone_number)
  const [userEmail, setEmail] = useState(email)
  const [updateBtn, setUpdateBtn] = useState(false)
  const [languageList, setLanguageList] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showTransferRoleModal, setShowTransferRoleModal] = useState(false)
  const [modalType, setModalType] = useState('')
  const [orgName, setOrgName] = useState('')

  const [selectedLanguage, setSelectedLanguage] = useState('')
  const [showLangUpdateButton, setShowLangUpdateButton] = useState(false)

  useEffect(() => {
    if (isUserAuthorized()) {
      setSelectedLanguage(getCurrentLanguageFromCookie())
      dispatch(commonActions.getLanguages(1, 'front'))
    }
  }, [])

  useEffect(() => {
    if (nameUpdated) {
      dispatch(loginActions.setName(firstNameIp.value, lastNameIp.value))
    }
  }, [nameUpdated])

  useEffect(() => {
    if (languages && languages.length > 0) {
      const updatedWithFlags = languages.map((lang) => {
        lang.value = lang.code
        lang.label = `${lang.name} ${getFlagEmoji(lang.code)}`
        return lang
      })
      setLanguageList(updatedWithFlags)
    }
  }, [languages])

  useEffect(() => {
    setFirstNameIp({ ...firstNameObj, value: firstname })
    setLastNameIp({ ...lastNameObj, value: lastname })
    setPhoneNumber(phone_number)
    setEmail(email)
  }, [userDetails])

  useEffect(() => {
    if (success && !userDetailLoading) {
      dispatch(settingsActions.setUpdateFormActive(false))
    }
  }, [success, userDetailLoading])

  useEffect(() => {
    const { loading, updated, value } = languageFromReducer
    if (!loading && updated) {
      setSelectedLanguage(value)
      localStorage.setItem('current_lang', value)
      setCookie(appConstantSettings.LANG_COOKIE_NAME, value, appConstantSettings.LANG_COOKIE_EXP_DAYS)
      location.reload()
    }
  }, [languageFromReducer])

  const handleInput = (type, e) => {
    if (type === 'fname') {
      setFirstNameIp({ ...firstNameIp, value: e.target.value })
    } else if (type === 'lname') {
      setLastNameIp({ ...lastNameIp, value: e.target.value })
    }
    setUpdateBtn(true)
  }

  const handleValidation = () => {
    validate()

    let payload = {
      firstname: firstNameIp.value,
      lastname: lastNameIp.value
    }
    dispatch(settingsActions.putNames(payload))
    setUpdateBtn(false)
  }

  const validateName = (name) => /^[0-9A-Za-z\s\-]+$/.test(name)

  const validate = () => {
    if (!firstNameIp.value) {
      setFirstNameIp({
        ...firstNameIp,
        hasError: true,
        errorMessage: t('account_settings.error_messages.first_name_req')
      })
      return false
    }
    if (!lastNameIp.value) {
      setLastNameIp({ ...lastNameIp, hasError: true, errorMessage: t('account_settings.error_messages.last_name_req') })
      return false
    }
    if (!validateName(firstNameIp.value)) {
      setFirstNameIp({
        ...firstNameIp,
        hasError: true,
        errorMessage: t('account_settings.error_messages.first_name_invalid')
      })
      return false
    }
    if (!validateName(lastNameIp.value)) {
      setLastNameIp({
        ...lastNameIp,
        hasError: true,
        errorMessage: t('account_settings.error_messages.last_name_invalid')
      })
      return false
    }

    setFirstNameIp({ ...firstNameIp, hasError: false, errorMessage: '' })
    setLastNameIp({ ...lastNameIp, hasError: false, errorMessage: '' })
    return true
  }

  const handleCredLink = (value, e) => {
    e.preventDefault()
    dispatch(settingsActions.setCodeError(false))
    dispatch(settingsActions.setSuccess(false))
    dispatch(settingsActions.setResetSuccess(false))
    dispatch(settingsActions.setInitial())
    dispatch(settingsActions.setCredValue(value))
    dispatch(settingsActions.setVerificationFormActive(false))
    dispatch(settingsActions.setUpdateFormActive(true))
  }

  const handleSelectLanguage = (selectedLang) => {
    setSelectedLanguage(selectedLang.value)
    setShowLangUpdateButton(true)
  }

  const saveLanguage = () => {
    setShowLangUpdateButton(false)

    // nativeapp
    if (isNative) {
      redirectToPage(`/0/settings/account/update?language=${selectedLanguage}`, isNative)
    }

    dispatch(settingsActions.updateLanguage('language', selectedLanguage))
  }

  const hideModal = () => {
    setShowModal(false)
    setModalType('')
  }

  const hideTransferRoleModal = () => {
    setShowTransferRoleModal(false)
  }
  const openModal = (type) => {
    if (isNative && urlSearchParams('current_organization')) {
      let current_organization = JSON.parse(urlSearchParams('current_organization'))
      if (checkNested(current_organization, 'info', 'name')) {
        setOrgName(current_organization.info.name)
        hideModal()
        setModalType(type)
        setShowModal(true)
        return
      }
    }
    if (checkNested(organization, 'current_organization', 'info', 'name')) {
      setOrgName(organization.current_organization.info.name)
      hideModal()
      setModalType(type)
      setShowModal(true)
    }
  }

  return (
    <div className={`${styles.mainWrapper}`}>
      <div className={`${styles.boxWrapper}`}>
        <header className={`${styles.header}`}>{t('account_settings.main_form.heading')}</header>
        <div className={`${styles.formWrapper}`}>
          <TextBox
            customWrapperCss={styles.textBox}
            customLabelCss={styles.label}
            fieldInfo={firstNameIp}
            label={t('account_settings.main_form.first_name')}
            placeholder={t('account_settings.main_form.first_name_pl')}
            onChange={(e) => handleInput('fname', e)}
            disabled={!user_properties?.my_settings_edition?.with_firstname}
          />
          <TextBox
            customWrapperCss={styles.textBox}
            customLabelCss={styles.label}
            fieldInfo={lastNameIp}
            label={t('account_settings.main_form.last_name')}
            placeholder={t('account_settings.main_form.last_name_pl')}
            onChange={(e) => handleInput('lname', e)}
            disabled={!user_properties?.my_settings_edition?.with_lastname}
          />
          {updateBtn && (
            <Button
              text={t('account_settings.main_form.buttons.update')}
              handleClick={handleValidation}
              customStyle={styles.updateBtn}
              size='large'
            />
          )}
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>
              {t('account_settings.main_form.email')}
              <span>{userEmail}</span>
            </div>
            <Link
              to='/0/settings/account/update-email'
              className={`${styles.link} ${!user_properties?.my_settings_edition?.with_email ? 'pointer-none' : ''}`}
              onClick={(e) => handleCredLink('email', e)}>
              {t('account_settings.main_form.buttons.email')}
              <span>
                <Icon name='arrow-right' alt='' />
              </span>
            </Link>
          </div>
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>
              {t('account_settings.main_form.password')}
              <input type='password' value='12345678' className={`${styles.pwdInput}`} readOnly />
            </div>
            <Link
              to='/0/settings/account/update-password'
              className={`${styles.link} ${!user_properties?.my_settings_edition?.with_password ? 'pointer-none' : ''}`}
              onClick={(e) => handleCredLink('password', e)}>
              {t('account_settings.main_form.buttons.password')}
              <span>
                <Icon name='arrow-right' alt='' />
              </span>
            </Link>
          </div>
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>
              {t('account_settings.main_form.number')}
              <span>{phoneNumber}</span>
            </div>
            <Link
              to='/0/settings/account/update-number'
              className={`${styles.link}`}
              onClick={(e) => handleCredLink('number', e)}>
              {t('account_settings.main_form.buttons.number')}
              <span>
                <Icon name='arrow-right' alt='' />
              </span>
            </Link>
          </div>
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>
              {t('formlabel.dob')}
              <span>{formatDate(birthday, getDateFormat2())}</span>
            </div>
            <Link
              to='/0/settings/account/update-number'
              className={`${styles.link}`}
              onClick={(e) => handleCredLink('dob', e)}>
              {t('account_settings.main_form.buttons.dob')}
              <span>
                <Icon name='arrow-right' alt='' />
              </span>
            </Link>
          </div>
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>
              {t('formlabel.gender')}
              {gender && <span>{t(`signup.information_module.${gender}`)}</span>}
            </div>
            <Link
              to='/0/settings/account/update-number'
              className={`${styles.link}`}
              onClick={(e) => handleCredLink('gender', e)}>
              {t('account_settings.main_form.buttons.gender')}
              <span>
                <Icon name='arrow-right' alt='' />
              </span>
            </Link>
          </div>
          <div className={`${styles.userCred}`}>
            <div className={`${styles.innerWrapper}`}>{t('global.language')}</div>
            <div className={styles.languageForm}>
              <Dropdown1
                value={languageList.find((x) => x.value === selectedLanguage)}
                onChange={handleSelectLanguage}
                options={languageList}
                className={styles.languageDropdown}
                closeMenuOnSelect={true}
                isSearchable={false}
              />
              {showLangUpdateButton && (
                <Button text={t('global.update')} customStyle={styles.updateLangBtn} handleClick={saveLanguage} />
              )}
            </div>
          </div>
          <div className={styles.links}>
            <Link to='/0/community-guidelines/'>{t('account_settings.sidebar.first_bottom_nav')}</Link>
            <Link to='/0/terms-of-services/'>{t('account_settings.sidebar.second_bottom_nav')}</Link>
            <Link to='/0/privacy-policy/'>{t('account_settings.sidebar.third_bottom_nav')}</Link>
          </div>
          {isMobile && (
            <React.Fragment>
              <button className={styles.closeAccountBtn} onClick={() => openModal('deactivate')}>
                {t('account_settings.sidebar.deactivateAcc')}
              </button>
              {/* <button className={styles.closeAccountBtn} onClick={() => openModal('delete')}>
                {t('account_settings.sidebar.deleteAcc')}
              </button> */}
            </React.Fragment>
          )}
        </div>
      </div>
      {isMobile && showModal && modalType && (
        <CloseAccountModal orgName={orgName} showModal={showModal} modalType={modalType} hideModal={hideModal} />
      )}
      {isMobile && showTransferRoleModal && (
        <TransferRoleModal showModal={showTransferRoleModal} hideModal={hideTransferRoleModal} screen='select-group' />
      )}
    </div>
  )
}
